import * as moment from 'moment';
import { DateFormatHelper, DateFormat } from '../../wtFramework';
export function axisFormat(min: Date, max: Date, plotWidth: number, formatHelper: DateFormatHelper): { format: DateFormat, ticks: Date[] } {
    const subtract = moment.duration(moment(max).diff(moment(min)));
    const format = formatHelper.format(subtract);
    const ticks = formatHelper.getTicks([min, max], plotWidth, subtract,
        format.length);
    return { format, ticks };
}